<template>
    <div v-show="visible" class="loading-box" :class="small ? ' no-logo' : ''">
        <img v-if="!small" :src="require('Assets/loader-logo.svg')" width="106" class="loader-logo" alt="" />
        <img :src="require('Assets/loader.svg')" width="45px" alt=""/>
    </div>
</template>

<script>

    export default {
        name: 'pre-loader-component',
        props: {
            visible: Boolean,
            small: Boolean
        },
    }
</script>


<style scoped>

</style>
